import Button from '@carvana/ds-button';
import { useContext } from 'react';
import SoftPullStatus from '~/constants/softPullStatus';
import { useConfiguration } from '~/context/common/StaticContext';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import ModalContext from '~/context/vdp/ModalContext';
import { useSectionAnalytics } from '~/context/vdp/SectionAnalyticsContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import useShouldHideSectionsForMiniHero from '~/hooks/vdp/selectors/useShouldHideSectionsForMiniHero';
import useSoftPullStatus from '~/hooks/vdp/selectors/useSoftPullStatus';
import { PricingError } from '~/services/common/contracts/PricingResponse';

export default function GetYourTerms() {
  const { shouldUseTitleCasing } = useConfiguration();
  const { vehiclePricingError } = useContext(UserVehicleContext);
  const { analyticsId, analyticsAttributes } = useSectionAnalytics();
  const { setSoftPullModalOpen } = useContext(ModalContext);
  const { isLoaded, softPullStatus } = useSoftPullStatus();
  const isDealership = useIsDealershipPage();
  const shouldHideSectionsForMiniHero = useShouldHideSectionsForMiniHero();

  const noSoftPull = softPullStatus === SoftPullStatus.None;
  const showGetTerms =
    isLoaded &&
    noSoftPull &&
    !isDealership &&
    !shouldHideSectionsForMiniHero &&
    vehiclePricingError === PricingError.None;

  return showGetTerms ? (
    <Button
      className="hidden self-center bg-background-primary-subtle sm:block"
      data-adobe-id="get-your-terms"
      data-analytics-id={analyticsId}
      data-analytics-attributes={JSON.stringify({
        ...analyticsAttributes,
        description: 'soft pull',
        location: 'no terms',
        text: shouldUseTitleCasing ? 'Get Your Terms' : 'Get your terms'
      })}
      data-testid="get-your-terms"
      onClick={() => setSoftPullModalOpen(true)}
      variant="secondary"
      size="xs"
      utility
    >
      {shouldUseTitleCasing ? 'Get Your Terms' : 'Get your terms'}
    </Button>
  ) : null;
}
